// material-ui
import { Typography, Button, Stack, Input, Alert, Table, TableBody, TableCell, TableRow, TableHead, Select, MenuItem, FormHelperText, Skeleton } from '@mui/material';
import Pagination from 'components/@extended/Pagination';

// project import
import MainCard from 'components/MainCard';
import CsvUploader from 'components/Uploaders/CsvUploader';
import { isShopifyApp } from 'context/UserAuthContext';
import React from 'react';
import { Link } from 'react-router-dom';
import { getRequest } from 'utils/apiRequest';


// ==============================|| SAMPLE PAGE ||============================== //

const TrackingNumbersLoading = () => {
    return (<>
        {[...Array(50)].map((v, i)=>{
            return (
                <TableRow key={i}>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width="40%" />
                </TableCell>
                </TableRow>
            )
        })}
    </>)
}


const TrackingNumbers = () => {
    const [trackingNumbers, setTrackingNumbers] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [pagination, setPagination] = React.useState({
        current: 1,
        total: 1,
    });
    React.useEffect(() => {
        getTrackingNumbers();
    }, []);
    const getTrackingNumbers = (page = 1) => {
        setLoading(true);
        getRequest('/account/tracking?page='+page).then((d) => {
            if(d && d.data){
                setTrackingNumbers(d.data);
                setPagination({
                    current: d.current_page,
                    total: d.last_page,
                })
            }
        }).finally(()=>{
            setLoading(false);
        })
    }
    const setPage = (p) => {
        getTrackingNumbers(p);
      };
    return (
        <MainCard title="Tracking Numbers" secondary={!isShopifyApp() && <CsvUploader buttonText="Upload CSV" type="tracking" />}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Tracking Number</TableCell>
                        <TableCell>Carrier</TableCell>
                        <TableCell>Order Number</TableCell>
                        <TableCell>Warehouse</TableCell>
                        <TableCell>Ship From</TableCell>
                        <TableCell>Ship To</TableCell>
                        <TableCell>Ship Date</TableCell>
                        <TableCell>Delivery Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? <TrackingNumbersLoading /> : (<>
                    {trackingNumbers.map((tn, i) => {
                        return (tn.tracking_number ? (<TableRow key={i}>
                            <TableCell>
                                <Link to={"/transit/"+tn.tracking_number}>
                                {tn.tracking_number}
                                </Link>
                            </TableCell>
                            <TableCell>
                                {tn.carrier && tn.carrier.name}
                            </TableCell>
                            <TableCell>
                                {tn.order_number}
                            </TableCell>
                            <TableCell>
                                {tn.warehouse && tn.warehouse.name}
                            </TableCell>
                            <TableCell>
                                {tn.ship_from && tn.ship_from.zip}
                            </TableCell>
                            <TableCell>
                                {tn.ship_to && tn.ship_to.zip}
                            </TableCell>
                            <TableCell>
                                {tn.shipped_at}
                            </TableCell>
                            <TableCell>
                                {tn.delivered_at}
                            </TableCell>
                        </TableRow>) : null
                        )
                    })}</>)}
                </TableBody>
            </Table>
            <Pagination
                count={pagination.total} 
                page={pagination.current} 
                setPage={(p) => setPage(p)}
                />
        </MainCard>);
}

export default TrackingNumbers;
